<div class="d-flex flex-column flex-md-row justify-content-md-around">
    <div class="form-group " *ngIf="verifyCycle?.length ==0">
        <label for="">Choisir la séance</label>
        <ng-select class="mx-1"  (change)="loadList($event)" style="min-width: 250px;">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let course of courses; let i=index" [value]="i">{{course?.name}} ({{course.classroom}})</ng-option>
        </ng-select>
    </div>
    <div class="form-group " *ngIf="verifyCycle?.length !=0">
        <label for="">Choisir la classe</label>
        <ng-select class="mx-1" id="" (change)="loadlist($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let c of classrooms" [value]="c">{{c.classroom?.name}}</ng-option>
        </ng-select>
    </div>
    <div class="form-group" >
        <label for="">Choisir la période</label>
        <ng-select class="mx-1" (change)="setPeriod($event)">
            <ng-option selected disabled></ng-option>
            <ng-option *ngFor="let period of periods" [value]="period?.id">{{period?.name}}</ng-option>
        </ng-select>
    </div>
</div>

<div class="row mb-5">
    <div class="col-12">
        <div class=" text-center border" >
            <div class="ag-bg-red  row no-gutters p-1" style="height: 3rem; border-radius: 10px 10px 0px 0px;">
                <div class="col-md-1 col-12">
                    <span class="text-white align-self-center">#</span>
                </div>
                <div class="col-md-7 col-12 text-start">
                    <span class="text-white ">Libellé</span>
                </div>
                <div class="col-md-4 col-12 text-center" >
                    <span class="text-white ">Statut</span>
                </div>
            </div>
              
            <div class="mb-3" style="height: 65vh; overflow-y: scroll; overflow-x: hidden; ">
                <table class="table">
                    <tr class="p-0" *ngFor="let d of data; let i=index">
                        <td class="">
                                {{i+1}}
                        </td>
                        <td class="text-start w-100">
                                    <span class="text-dark h6"><strong><small>{{d.identity}}</small></strong></span>
                        </td>
                        <td class="d-flex flex-column" >
                           <select class="form-control-sm p-1 mb-1" name="type" [(ngModel)]="d.type">
                            <option *ngFor="let ac of attendance_categories" [value]="ac">{{ac}}</option>
                           </select>
                            <input *ngIf=" d.type != attendance_categories[1]" type="text" class="mb-1" placeholder="Motif" [(ngModel)]="d.motif" name="motif">

                            <input *ngIf=" d.type != attendance_categories[1]" type="file" change="upload($event,i)">
                        </td>
                    </tr>
                </table>
                
            </div>

            <div class="text-center">
                <button class="btn btn-success btn-sm" [disabled]="loading" (click)="store()"> Enregistrer cette fiche de présence</button>
            </div>
        </div>
    </div>
</div>